export const TermsPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="terms-page">
      {/* Hero Banner */}
      <section className="py-20 md:py-28 hero-glow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-heading text-white animate-fade-in-up">
            Terms of Service
          </h1>
          <p className="text-muted-foreground mt-4 animate-fade-in-up stagger-1">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert max-w-none space-y-8">
            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing and using Niyanta.io's services, you accept and agree to be bound by these 
                Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">2. Description of Services</h2>
              <p className="text-muted-foreground leading-relaxed">
                Niyanta.io provides business management solutions including HR Management, Project Management, 
                Sales Management, Marketing Management, Finance Management, and Custom IT Solutions. We reserve 
                the right to modify, suspend, or discontinue any part of our services at any time.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">3. User Responsibilities</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                As a user of our services, you agree to:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use the services only for lawful purposes</li>
                <li>Not interfere with or disrupt the services</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">4. Intellectual Property</h2>
              <p className="text-muted-foreground leading-relaxed">
                All content, features, and functionality of our services, including but not limited to text, 
                graphics, logos, and software, are the exclusive property of Niyanta.io and are protected by 
                international copyright, trademark, and other intellectual property laws.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">5. Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                Niyanta.io shall not be liable for any indirect, incidental, special, consequential, or 
                punitive damages resulting from your use of or inability to use our services. Our total 
                liability shall not exceed the amount paid by you for the services.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">6. Termination</h2>
              <p className="text-muted-foreground leading-relaxed">
                We may terminate or suspend your access to our services immediately, without prior notice, 
                for any reason whatsoever, including without limitation if you breach these Terms of Service.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">7. Governing Law</h2>
              <p className="text-muted-foreground leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of India, 
                without regard to its conflict of law provisions. Any disputes shall be subject to the 
                exclusive jurisdiction of the courts in Gurgaon, India.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">8. Changes to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify users of any 
                material changes by posting the new Terms of Service on this page with an updated 
                revision date.
              </p>
            </div>

            <div className="glass rounded-2xl p-8">
              <h2 className="text-2xl font-semibold font-heading text-white mb-4">9. Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-primary mt-2">
                <a href="mailto:admin@niyanta.io" className="hover:underline">admin@niyanta.io</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
